import script from "./StyledName.vue?vue&type=script&setup=true&lang=js"
export * from "./StyledName.vue?vue&type=script&setup=true&lang=js"

import "./StyledName.vue?vue&type=style&index=0&id=4e9f366f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9f366f"]])

export default __exports__